// Some coach profiles carry their role in the name ("Jane Doe, Nutritionist").
export const roleLine = (name: string, role: string): string | null =>
  name.toLowerCase().includes(role.toLowerCase()) ? null : role

export const memberLabel = ({ name, role }: { name: string; role: string }): string =>
  roleLine(name, role) ? `${name} (${role})` : name
